import { render, staticRenderFns } from "./AdminSaleEdit.vue?vue&type=template&id=30885f71"
import script from "./AdminSaleEdit.vue?vue&type=script&lang=js"
export * from "./AdminSaleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports